<h4 *ngIf="!edit">Create new partner</h4>
<h4 *ngIf="edit">Edit partner /{{item.code}}/{{item.id}}/</h4>
<form (ngSubmit)="save()" #itemForm="ngForm">
    <div class="item-panel partner-panel">
        <div class="p-grid">
            <div class="p-fluid p-md-6">
                <div class="p-field">
                    <label for="name">Code *</label>
                    <input type="text" size="30" pInputText name="code" id="code" 
                           [required]="true" maxlength="50" autocomplete="off" [(ngModel)]="item.code"> 
                    <p-message severity="error" 
                               [text]="itemForm.controls['code'].errors['required'] ? 'code is required' : itemForm.controls['code'].errors['maxlength'] ? 'Must be smaller than 50 characters' : ''"
                               *ngIf="!itemForm.controls['code']?.valid&&itemForm.controls['code']?.dirty"></p-message>
                </div>
                <div class="p-field">
                    <label for="name">Nom *</label>
                    <input type="text" size="30" pInputText name="name" id="name" 
                           [required]="true" maxlength="150" minlength="3" autocomplete="off" [(ngModel)]="item.name"> 

                    <p-message severity="error" 
                               [text]="itemForm.controls['name'].errors['required'] ? 'name is required' : itemForm.controls['name'].errors['maxlength'] ? 'Must be smaller than 150 characters' : ''"
                               *ngIf="!itemForm.controls['name']?.valid&&itemForm.controls['name']?.dirty"></p-message>
                </div>
                <div class="p-field">
                    <label for="name">N° Contribualbe *</label>
                    <input type="text" size="30" pInputText name="niu" id="niu" 
                           [required]="true" maxlength="17" minlength="17" maxlength="17" autocomplete="off" [(ngModel)]="item.niu"> 

                    <p-message severity="error" 
                               [text]="itemForm.controls['niu'].errors['required'] ? 'niu is required' : itemForm.controls['niu'].errors['maxlength'] ? 'Must be smaller than 17 characters' : ''"
                               *ngIf="!itemForm.controls['niu']?.valid&&itemForm.controls['niu']?.dirty"></p-message>
                </div>
                <div class="p-field p-pt-5">
                    <p-checkbox name="active" label="Active" [(ngModel)]="item.active" binary="true"></p-checkbox>
                </div>

            </div>
            <div class="p-fluid p-md-6">
                <div class="p-field ">
                    <label>Partner Groups *</label>
                    <p-listbox   
                        [listStyle]="{'height':'150px'}" 
                        name="partnerGroupIds" [options]="partnerGroups" 
                        [(ngModel)]="item.partnerGroupIds" optionLabel="name" 
                        filter="filter" multiple="true" checkbox="true" dataKey="id">

                        <p-footer>
                            <div class="p-col p-col-fixed">
                                <p-tag *ngFor="let pg of item.partnerGroupIds" styleClass="p-mr-2" [value]="pg.name"></p-tag>
                            </div>
                        </p-footer>
                    </p-listbox>
                </div>
            </div>
        </div>
        <div class="ui-g">
            <div class="ui-g-4">
                <button pButton [disabled]="!itemForm.valid" type="submit" label="Validate" icon="pi pi-check" iconPos="left" style="margin-right: 0.5em;" class="p-button-success"></button>
                <button pButton routerLink="/backendadmin/partners"  type="button" label="Cancel"  icon="pi pi-times" iconPos="left" style="margin-right: 0.5em;" class="p-button-danger"></button>
            </div>
        </div>

    </div>
</form>

